<template>
  <div class="us_app">
    <div class="new-main">

      <!-- 1. 메인 배너 + 우측 빠른 링크 -->
      <div class="new-inner">
        <div class="lay_left">
          <section class="user_section">
            <article class="view intro slide_wrap">
              <div class="main_slide">
                <swiper
                  class="swiper mySwiper swiper-wrapper"
                  :options="swiperOption"
                  :navigation="true"
                  ref="mainSwiper"
                >
                  <swiper-slide v-for="(item, idx) in imagesList" :key="idx">
                    <div class="img_box">
                      <img :src="item.img" alt="" />
                    </div>
                  </swiper-slide>
                </swiper>
                <div class="swiper-pagination"></div>
                <div class="control_wrap">
                  <div class="swiper-prev" slot="button-prev">
                    <b-icon icon="chevron-left"></b-icon>
                  </div>
                  <div class="swiper-next" slot="button-next">
                    <b-icon icon="chevron-right"></b-icon>
                  </div>
                </div>
                <div class="slide_info_panel" v-if="doctorInfo.isLoggedIn">
                  <p class="panel_clinic">{{ doctorInfo.clinicNm }}</p>
                  <p class="panel_doctor">{{ doctorInfo.doctorNm }} 원장</p>
                  <p class="panel_license">면허번호 {{ doctorInfo.doctorLicenseNum }}</p>
                </div>
              </div>
            </article>
          </section>
        </div>
        <div class="lay_right">
          <ul class="main_list">
            <li
              v-for="(item, idx) in mainItem"
              :key="idx"
              @mouseenter="hoverIndex = idx"
              @mouseleave="hoverIndex = null"
            >
              <router-link :to="item.path">
                <div class="icon_box">
                  <img :src="hoverIndex === idx ? item.hoverImg : item.img" alt="" />
                </div>
                <div class="main-item">
                  <h4>{{ item.title }}</h4>
                  <p style="white-space: pre-wrap">{{ item.desc }}</p>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </div>

      <!-- 2. 빠른 메뉴 4개 -->
      <ul class="side_menu">
        <li>
          <router-link to="/dictionary">
            <div class="txt_box">
              <h6>비방사전 검색</h6>
              <p class="prewrap">이 처방 총내!</p>
              <span class="menu_link">비방 둘러보기 →</span>
            </div>
            <div class="icon">
              <img src="@/assets/img/icon/icon_menu3.png" alt="" />
            </div>
          </router-link>
        </li>
        <li>
          <router-link to="/dictionary/register">
            <div class="txt_box">
              <h6>비방 등록 참여</h6>
              <p class="prewrap">비방을 등록하면 3000P</p>
              <span class="menu_link">비방 둘러보기 →</span>
            </div>
            <div class="icon">
              <img src="@/assets/img/icon/icon_menu_arrow.png" alt="" />
            </div>
          </router-link>
        </li>
        <li>
          <router-link to="/mypage">
            <div class="txt_box">
              <h6>처방 내역 및 배송조회</h6>
              <p class="prewrap">탕전 및 약속처방의 내역과{{ '\n' }}배송정보를 알려드립니다.</p>
            </div>
            <div class="icon">
              <img src="@/assets/img/icon/icon_menu1.png" alt="" />
            </div>
          </router-link>
        </li>
        <li>
          <router-link to="/osdReport">
            <div class="menu_badge">신고하기</div>
            <div class="txt_box">
              <h6>원외탕전 신고하기</h6>
              <p class="prewrap">원외탕전 서류 접수를{{ '\n' }}도와 드립니다.</p>
            </div>
            <div class="icon">
              <img src="@/assets/img/icon/icon_menu2.png" alt="" />
            </div>
          </router-link>
        </li>
      </ul>

      <!-- 3. 최근 등록 비방 + 코끼리원외등급 + 본초랑고 -->
      <div class="middle-wrap">
        <!-- 최근 등록 비방 -->
        <div class="recent-bibang">
          <div class="section-hd">
            <h6 class="fwb m0">최근 등록 비방</h6>
            <router-link to="/dictionary/register" class="reg-btn">
              비방 등록하기
              <b-icon icon="plus"></b-icon>
            </router-link>
          </div>
          <div class="table_list">
            <table class="list">
              <colgroup>
                <col width="*" />
                <col width="170" />
                <col width="110" />
                <col width="100" />
              </colgroup>
              <thead>
                <tr>
                  <th>비방명</th>
                  <th>주요 효능</th>
                  <th>등록자</th>
                  <th>등록일</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, idx) in recentBibangList"
                  :key="idx"
                  class="pointer"
                >
                  <td class="al">{{ item.bibang_nm }}</td>
                  <td>{{ item.main_effect }}</td>
                  <td>{{ item.reg_nm }}</td>
                  <td>{{ item.reg_dt }}</td>
                </tr>
                <tr v-if="recentBibangList.length === 0">
                  <td colspan="4" class="ac">등록된 비방이 없습니다.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- 코끼리원외등급 -->
        <div class="grade-wrap">
          <div class="grade-medal-wrap">
            <img :src="gradeMedalImg" alt="" class="grade-medal" />
          </div>
          <div class="grade-info">
            <p class="grade-label">코끼리원외등급</p>
            <p class="grade-current">
              현재 등급 <strong>LV.{{ gradeInfo.level }} {{ gradeInfo.gradeName }}</strong>입니다
            </p>
            <div class="grade-progress-area">
              <div class="grade-progress-bar">
                <div
                  class="grade-progress-fill"
                  :style="{ width: gradeInfo.progressPct + '%' }"
                ></div>
              </div>
              <p class="grade-next-txt">
                <strong>{{ gradeInfo.remainExp }} EXP</strong> 채우면<br />
                Lv{{ gradeInfo.level + 1 }}. {{ gradeInfo.nextGradeName }}가 됩니다
              </p>
            </div>
            <router-link to="/mypage/grade" class="grade-benefit-btn">
              등급 혜택 보기 →
            </router-link>
          </div>
        </div>

        <!-- 본초랑고 배너 -->
        <div class="bonchorang-wrap">
          <div class="bonchorang-badge">바로가기</div>
          <p class="bonchorang-title">경험치와 포인트가<br />모이는 본초랑고</p>
          <div class="bonchorang-img">
            <img src="@/assets/img/layout/bonchorang.png" alt="" />
          </div>
          <router-link to="/bonchorang" class="bonchorang-link">
            본초랑고 바로가기 →
          </router-link>
        </div>
      </div>

      <!-- 4. 애니메이션 배너 -->
      <div class="animation_banner">
        <div class="ani_wrap">
          <div class="ani_item">
            <img src="@/assets/img/layout/banner_truck.png" alt="" />
          </div>
          <div class="ani_item">
            <img src="@/assets/img/layout/banner_truck.png" alt="" />
          </div>
        </div>
      </div>

      <!-- 5. 공지사항 + 배송안내 -->
      <div class="new-inner user_section">
        <div class="lay_left">
          <h6 class="fwb m0 mb30">공지사항</h6>
          <div class="table_list">
            <table class="list">
              <colgroup>
                <col width="*" />
                <col width="100" />
              </colgroup>
              <tbody>
                <tr
                  v-for="(item, index) in noticeList"
                  :key="index"
                  @click="fn_move_noticeDetail"
                  class="pointer"
                >
                  <td class="al" style="height: 65px; line-height: 65px">
                    <span class="list_style">{{ item.board_notice_title }}</span>
                  </td>
                  <td>
                    <span>{{ item.reg_dt }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="lay_right">
          <div class="delivery">
            <p>택배 <strong>배송 안내</strong></p>
            <div class="txt_box">
              <div>
                <div class="title">
                  탕전 처방
                  <div class="_badge">당일배송</div>
                </div>
                <p>월 - 금 : 오전 1시 이전 결제 완료 시</p>
                <p>토요일 : 오전 10시 이전 결제 완료 시</p>
              </div>
              <div>
                <div class="title">
                  약속 처방
                  <div class="_badge">당일배송</div>
                </div>
                <p>월 - 금 : 오후 3시 이전 결제 완료 시</p>
                <p>토요일 : 오후 10시 이전 결제 완료 시</p>
              </div>
            </div>
            <div class="delivery-notice">
              <p>한의사박력에의 경우 가정집은 당일 배송, 상가 또는 한의원은 다음날 배송되오니, 이용에 차질 없으시길 바랍니다.</p>
            </div>
            <div class="icon_box">
              <img src="@/assets/img/layout/banner1.png" alt="" />
            </div>
          </div>
        </div>
      </div>

    </div>
    <a class="kakao_icon" style="width: 80px; height: 80px" />
  </div>
</template>

<script>
import axios from 'axios'
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  computed: {
    doctorInfo() {
      return {
        isLoggedIn: !!this.$store.getters['clinicDoctorInfo/getClinicDoctorId'],
        clinicNm: this.$store.getters['clinicDoctorInfo/getClinicNm'],
        doctorNm: this.$store.getters['clinicDoctorInfo/getDoctorNm'],
        doctorLicenseNum: this.$store.getters['clinicDoctorInfo/getDoctorLicenseNum'],
      };
    },
    gradeMedalImg() {
      const lv = Math.min(Math.max(this.gradeInfo.level || 1, 1), 7);
      return require(`@/assets/img/layout/lv${lv}.png`);
    },
  },
  data() {
    return {
      hoverIndex: null,
      noticeList: [],
      recentBibangList: [],
      gradeInfo: {
        level: 5,
        gradeName: '임상고수',
        nextGradeName: '명인한의사',
        remainExp: 200,
        progressPct: 60,
      },
      mainItem: [
        {
          title: "탕전 처방",
          desc: "정확하고 깨끗한\n탕전 처방",
          path: "/application",
          img: require("@/assets/img/layout/medicine.png"),
          hoverImg: require("@/assets/img/layout/medicine_on.png"),
        },
        {
          title: "첩약건보",
          desc: "건강보험으로 처방하는\n첩약건보",
          path: "/insurance",
          img: require("@/assets/img/layout/point.png"),
          hoverImg: require("@/assets/img/layout/point_on.png"),
        },
        {
          title: "공진단 처방",
          desc: "맛과 효능이 뛰어난\n공진단",
          path: "/promisGoodsList",
          img: require("@/assets/img/layout/ball.png"),
          hoverImg: require("@/assets/img/layout/ball_on.png"),
        },
        {
          title: "약속 처방",
          desc: "미리 미리 준비하는\n약속 처방",
          path: "/promisGoodsList",
          img: require("@/assets/img/layout/promise.png"),
          hoverImg: require("@/assets/img/layout/promise_on.png"),
        },
        {
          title: "내 포인트",
          desc: "선 결제 시 최대 3%\n포인트 적립",
          path: "#",
          img: require("@/assets/img/layout/history.png"),
          hoverImg: require("@/assets/img/layout/history_on.png"),
        },
      ],
      swiperOption: {
        effect: "slide",
        spaceBetween: 10,
        allowTouchMove: false,
        autoplay: {
          delay: 5000,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: "bullets",
        },
        loop: true,
        navigation: {
          nextEl: ".swiper-next",
          prevEl: ".swiper-prev",
        },
      },
      imagesList: [
        { img: require("@/assets/img/layout/main01.jpg") },
        { img: require("@/assets/img/layout/main02.jpg") },
      ],
    };
  },
  mounted() {
    this.fn_search_notice();
    this.fn_search_recent_bibang();
    this.fn_search_grade_info();
  },
  methods: {
    fn_search_notice() {
      axios
        .post("/api/user/board/getMainNotice")
        .then((res) => {
          this.noticeList = res.data.mainNotice;
        })
        .catch((err) => console.log(err));
    },
    fn_search_recent_bibang() {
      axios
        .post("/api/user/bibang/getRecentBibangList")
        .then((res) => {
          this.recentBibangList = res.data.recentBibangList || [];
        })
        .catch((err) => console.log(err));
    },
    fn_search_grade_info() {
      axios
        .post("/api/user/grade/getGradeInfo")
        .then((res) => {
          if (res.data.gradeInfo) {
            this.gradeInfo = res.data.gradeInfo;
          }
        })
        .catch((err) => console.log(err));
    },
    fn_move_noticeDetail() {
      // this.$router.push('UserNoticeDetail')
    },
  },
};
</script>

<style scoped>
/* ─── 빠른 메뉴 링크 텍스트 ─── */
.side_menu li a .menu_link {
  display: inline-block;
  margin-top: 10px;
  font-size: 1.3rem;
  color: #8c383b;
  font-weight: 600;
}

/* ─── 중간 3컬럼 래퍼 ─── */
.middle-wrap {
  display: flex;
  gap: 30px;
  margin-bottom: 40px;
}

/* ─── 최근 등록 비방 ─── */
.recent-bibang {
  flex: 1 1 0;
  min-width: 0;
  border: 1px solid #e9e9e9;
  border-radius: 16px;
  padding: 30px;
}
.section-hd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.section-hd h6 {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}
.reg-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 1.4rem;
  color: #555;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 6px 14px;
}
.reg-btn:hover {
  background-color: #f7f5f3;
}
.pointer {
  cursor: pointer;
}

/* ─── 코끼리원외등급 ─── */
.grade-wrap {
  width: 280px;
  flex-shrink: 0;
  border: 1px solid #e9e9e9;
  border-radius: 16px;
  padding: 30px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}
.grade-medal-wrap {
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.grade-medal {
  width: 100%;
  object-fit: contain;
}
.grade-info {
  width: 100%;
  text-align: center;
}
.grade-label {
  font-size: 1.3rem;
  color: #888;
  margin-bottom: 6px;
}
.grade-current {
  font-size: 1.5rem;
  line-height: 1.5;
  margin-bottom: 16px;
}
.grade-current strong {
  color: #8c383b;
  font-weight: 700;
}
.grade-progress-area {
  margin-bottom: 16px;
}
.grade-progress-bar {
  width: 100%;
  height: 8px;
  background-color: #efefef;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 10px;
}
.grade-progress-fill {
  height: 100%;
  background-color: #f0a500;
  border-radius: 4px;
  transition: width 0.4s ease;
}
.grade-next-txt {
  font-size: 1.3rem;
  color: #555;
  line-height: 1.6;
}
.grade-next-txt strong {
  color: #8c383b;
}
.grade-benefit-btn {
  display: inline-block;
  margin-top: 10px;
  padding: 10px 20px;
  background-color: #f7f5f3;
  border-radius: 30px;
  font-size: 1.4rem;
  color: #333;
  font-weight: 600;
}
.grade-benefit-btn:hover {
  background-color: #ede9e4;
}

/* ─── 본초랑고 배너 ─── */
.bonchorang-wrap {
  width: 260px;
  flex-shrink: 0;
  border-radius: 16px;
  background-color: #f7f5f3;
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}
.bonchorang-badge {
  display: inline-block;
  background-color: #555;
  color: #fff;
  font-size: 1.2rem;
  font-weight: 600;
  border-radius: 30px;
  padding: 4px 12px;
  margin-bottom: 12px;
  width: fit-content;
}
.bonchorang-title {
  font-size: 1.8rem;
  font-weight: 700;
  line-height: 1.5;
  margin-bottom: 10px;
}
.bonchorang-img {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bonchorang-img img {
  width: 100%;
  max-height: 160px;
  object-fit: contain;
}
.bonchorang-link {
  display: inline-block;
  margin-top: 12px;
  font-size: 1.4rem;
  color: #333;
  font-weight: 600;
}
.bonchorang-link:hover {
  text-decoration: underline;
}

/* ─── 배송안내 추가 노티스 박스 ─── */
.delivery-notice {
  border: 1px solid #e9e9e9;
  border-radius: 10px;
  padding: 16px 20px;
  margin-bottom: 20px;
  background-color: #fafafa;
}
.delivery-notice p {
  font-size: 1.4rem;
  color: #666;
  line-height: 1.6;
}
</style>